import React, { useCallback } from 'react'
import { pick } from 'lodash-es'
import { useTbViewStore } from '@vt/hooks'
import Table from '../binding/table'
import useAreaStore from '../areaStore'

/**
 * 点位绑定规则列表
 */
const User = function ({ areaBindUserTbId }) {
  const { ditto } = useTbViewStore((state) =>
    pick(state, ['layouts', 'ditto', 'setTbData', 'setFields'])
  )

  const { setAreaState, isCreateAreaBind } = useAreaStore((state) =>
    pick(state, ['setAreaState', 'isCreateAreaBind'])
  )

  const loadData = useCallback(
    (page, size) => {
      return ditto.fetchBindUserRule(areaBindUserTbId, page, size)
    },
    [ditto]
  )

  const onCreate = useCallback(() => {
    setAreaState({ isCreateAreaBind: true, areaBindType: 'user', ruleId: null })
  }, [])

  const onModify = useCallback((item) => {
    setAreaState({
      isCreateAreaBind: true,
      areaBindType: 'user',
      ruleId: item.id,
      ruleName: item.ruleName,
    })
  }, [])

  const onSwitch = useCallback(
    (...args) => {
      return ditto.switchBindUserRule(...args)
    },
    [ditto]
  )

  return (
    <Table
      loadData={loadData}
      onCreate={onCreate}
      onModify={onModify}
      switcher={onSwitch}
      visible={!isCreateAreaBind}
    />
  )
}

export default User
